/* ==========================================================================
   MONTAGE-THEME · <mt-tabs>
   --------------------------------------------------------------------------
   Reiter nach WAI-ARIA: Pfeiltasten, Home und End, genau ein Reiter in der
   Tabreihenfolge.

   Fortschrittliche Verbesserung: ohne dieses Skript stehen alle Panels
   untereinander und sind vollstaendig lesbar. Die Reiterleiste traegt im
   Markup ein hidden und wird erst hier sichtbar gemacht.
   ========================================================================== */
/* Gekapselt in einen sofort ausgefuehrten Ausdruck, weil mehrere Sektionen
   dieselbe Datei einbinden koennen. Zwei script-Tags mit derselben Adresse
   fuehrt der Browser zweimal aus, und eine Klasse im Modulrumpf wirft beim
   zweiten Mal "has already been declared". Innerhalb der Kapsel ist die
   zweite Ausfuehrung folgenlos, die Registrierungspruefung darunter faengt
   den Rest ab. */
(function () {
  class MontageTabs extends HTMLElement {
    connectedCallback() {
      this.leiste = this.querySelector('[role="tablist"]');
      this.knoepfe = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.leiste || this.knoepfe.length < 2 || this.knoepfe.length !== this.panels.length) return;

      this.leiste.removeAttribute('hidden');
      this.setAttribute('data-bereit', '');

      this.knoepfe.forEach((knopf, i) => {
        knopf.addEventListener('click', () => this.zeige(i));
        knopf.addEventListener('keydown', (e) => this.taste(e, i));
      });

      const start = this.panels.findIndex((p) => p.hasAttribute('data-aktiv'));
      this.zeige(start < 0 ? 0 : start, false);
    }

    zeige(index, fokussieren = true) {
      this.knoepfe.forEach((knopf, i) => {
        const aktiv = i === index;
        knopf.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        knopf.setAttribute('tabindex', aktiv ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => {
        const aktiv = i === index;
        panel.toggleAttribute('data-aktiv', aktiv);
        panel.toggleAttribute('hidden', !aktiv);
      });
      if (fokussieren) {
        this.knoepfe[index].focus();
        this.knoepfe[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    taste(event, index) {
      const letzter = this.knoepfe.length - 1;
      let ziel = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          ziel = index === letzter ? 0 : index + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          ziel = index === 0 ? letzter : index - 1;
          break;
        case 'Home':
          ziel = 0;
          break;
        case 'End':
          ziel = letzter;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.zeige(ziel);
    }
  }

  if (!customElements.get('mt-tabs')) {
    customElements.define('mt-tabs', MontageTabs);
  }
})();
